import { configureStore,combineReducers  } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "@store/slices/authSlice";
import appReducer from "@store/slices/appSlice";
import dashboardReducer from "@store/slices/dashboardSlice";
import modalReducer from "@store/slices/modalSlice";
import fileUploadReducer from "@store/slices/fileUploadSlice";
import translatorAdminReducer from "@store/slices/translatorAdminSlice";
import translatorReducer from "@store/slices/translatorSlice";
import validatorAdminReducer from "@store/slices/validatorAdminSlice";
import devnagriValidatorAdminReducer from "@store/slices/devnagriValidatorAdminSlice";
import validatorReducer from "@store/slices/validatorSlice";
import validatorProjectReducer from "@store/slices/validatorProjectSlice";
import translatorProjectReducer from "@store/slices/validatorProjectSlice";
import fileMetaReducer from "@store/slices/fileMetaSlice";
import fileLanguageReducer from "@store/slices/fileLanguageSlice";
import gaAdminReducer from "@store/slices/gaAdminSlice";
import devnagriValidatorReducer from "@store/slices/devnagriValidatorSlice";

import studentAuthReducer from "@store/slices/studentAuthSlice";
import studentDashReducer from "@store/slices/studentDashboard";
import loginPageReducer from "@store/slices/loginSlice";

const rootReducer = combineReducers({
    auth: authReducer,
    app: appReducer,
    dashboard: dashboardReducer,
    modal: modalReducer,
    fileUpload: fileUploadReducer,
    translator: translatorReducer,
    translatorAdmin: translatorAdminReducer,
    validatorAdmin: validatorAdminReducer,
    devnagriValidatorAdmin: devnagriValidatorAdminReducer,
    validator: validatorReducer,
    validatorProject: validatorProjectReducer,
    translatorProject: translatorProjectReducer,
    fileMeta: fileMetaReducer,
    fileLanguage: fileLanguageReducer,
    gaAdmin: gaAdminReducer,
    devnagriValidator: devnagriValidatorReducer,


    studentAuth: studentAuthReducer,
    studentDashboard: studentDashReducer,
    loginPage: loginPageReducer

});

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "auth",  
    "app",      
    "dashboard", 
    "modal",  
    "fileUpload",      
    "translator", 
    "translatorAdmin",  
    "validatorAdmin",      
    "devnagriValidatorAdmin", 
    "validator",  
    "validatorProject",      
    "translatorProject", 
    "fileMeta", 
    "fileLanguage",  
    "gaAdmin",      
    "devnagriValidator",  
    "studentAuth",
    "studentDashboard",
    "loginPage" 
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);


export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
        ],
      },
    }),
});

export const persistor = persistStore(store);
